export default "__VITE_ASSET__99915277__"